<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-25 17:30:33
-->
<template>
  <mrc_ess_table :headers="headers"
                 :hideAddBtn="true"
                 :paginationOptions="options"
                 @turnPage="getlist"
                 :isLoading="loading"
                 :slotKey="['created_utc_datetime']"
                 :items="desserts">
    <template v-slot:search>
      <v-row class="d-flex justify-end"
             style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px">
        <mrc_ess_advanceFilterAndSearchInput class="mt-4"
                                             v-model="systemSeniorQueryString"
                                             @success="getlist({ cpage: 1 })"
                                             :systemFieldMeta="systemFieldMeta"></mrc_ess_advanceFilterAndSearchInput>
      </v-row>
    </template>

    <template v-slot:item.created_utc_datetime="{ item }">
      {{ item.created_utc_datetime | changeDate() }}
    </template>
  </mrc_ess_table>
</template>

<script>
import {
  system_log_list
} from "@/service/api/system_log.js"
export default {
  components: {},
  props: {},
  data () {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      stepIndex: 1,
      dialog: false,
      disabled: true,
      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
    }
  },
  computed: {
    menulist () {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-serial-number"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-serial-number"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-serial-number"),
          type: "del",
        },
      ]
    },
    headers () {
      return [
        {
          text: this.$t("label_username"),
          align: "start",
          value: "account_name",
          sortable: false,
        },
        {
          text: this.$t("label_access_path"),
          align: "start",
          value: "button_url",
          sortable: false,
        },
        {
          text: this.$t("label_content"),
          align: "start",
          value: "content",
          sortable: false,
        },
        {
          text: this.$t("label_creation_time"),
          align: "start",
          value: "created_utc_datetime",
          sortable: false,
        },
        {
          text: this.$t("label_log_type"),
          align: "start",
          value: "log_type",
          sortable: false,
        },
        {
          text: this.$t("label_ip_address"),
          align: "start",
          value: "user_ip",
          sortable: false,
        },
        // {
        //   text: "",
        //   value: "actions",
        //   sortable: false,
        //   align: "end",
        //   width: "100",
        // },
      ]
    },
  },
  beforeCreate () {
    this.$store.commit("setCpage", 1)
  },
  async created () {
    this.$route.meta.title = 'label_system_log'
    this.$store.commit('set_page_title', 'label_system_log')
    await this.getBtnPermissionList()
  },
  watch: {
  },
  async mounted () {
    await this.getlist()
  },
  beforeDestroy () { },
  methods: {
    async getlist (obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.options = { ...this.options, ...obj }
      }
      const res = await system_log_list({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
  },
}
</script>

<style scoped>
.cardtitle {
  position: relative;
}
.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}
.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}
</style>
